import mutations from './mutations';
import actions from '@/store/settings/actions';
import getters from '@/store/settings/getters';

export const initialState = {
  toastList: [],
  popupList: [],
  crossFilterData: {},
  multiPlayedEvents: [],
  onSuccessBuyCallback: [],
};

export default {
  state: {
    ...initialState,
  },
  actions,
  mutations,
  getters,
};
